/* eslint-disable @typescript-eslint/no-explicit-any */
import querystring from 'query-string';

/**
 * A simple O(1) memoization helper to faciliate shallow-comparsion for
 * validation check.
 * This can only remember last one entry - this should be enough for most
 * rendering purposes.
 * @param {T} func The original function.
 * @return {T} The modified function.
 */
export function memoize<T extends(...args: any[]) => any>(func: T): T {
  let prevArgs: any[] | null = null;
  let prevResult: ReturnType<T> | null = null;
  return ((...args: any[]) => {
    if (
      prevArgs == null ||
      prevArgs.length !== args.length ||
      prevArgs.some((v, i) => v !== args[i])
    ) {
      prevArgs = args;
      prevResult = func(...args);
    }
    return prevResult;
  }) as T;
}

export const getQuery = memoize((url: string): { [key: string]: string } => {
  const search = (/\?(.+)$/.exec(url) || ['', ''])[1] ?? '';
  return querystring.parse(search.replace(/&amp;/g, '&')) as {
    [key: string]: string,
  };
});
